/* Keyboard access for the native div-based gallery and FAQ controls. */
document.addEventListener('keydown', function(event) {
  if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.shop-thumbnail[role="button"], .store-faq-question[role="button"]')) {
    event.preventDefault(); event.target.click();
  }
});
